// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2F29_","calendarButtons":"ClockData_calendarButtons__1gKvN"};